// error.actions.ts
import { createAction, props } from '@ngrx/store';
import { ErrorBase } from 'src/app/core/interfaces/error-base';

export const setError = createAction('[Error] Set Error', props<{ error: ErrorBase }>());

export const resetError = createAction('[Error] Reset Error');

export const globalError = createAction('[Error] Global Error', props<{ error: ErrorBase }>());
